import { LoadableAfterPaint } from '@confluence/loadable';

export const EnhanceOrientationTourNudgeLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EnhanceOrientationTourNudge" */ '../src/components/EnhanceOrientationTourNudge'
			)
		).EnhanceOrientationTourNudge,
});
